import React from 'react';
import * as _ from 'lodash';
import Helmet from 'react-helmet';
import ClipLoader from 'react-spinners/ClipLoader';

import {
  EXISTANCE_FLAG,
  HEADER_CONSTANTS, // ヘッダータイトル
  OTHER_SUBSCRIPTION_INSURANCE_STATUSES,
  EXCLUDE_KEY_COMPANY_BRANCH_PERMISSIONS,
  PERMISSION_GROUP_TYPE,
} from '../utilities/constants';
import _masterSlideLoader from '../utilities/masterSlideLoader';
import { messageUtility } from '../utilities/messageUtility';

import SessionStorageService from '../services/utilities/SessionStorageService';
import { GreenService } from '../services/GreenFile'; // 労安項目情報API
import { CompanyService } from '../services/Companies';
import { AttachDocuments } from '../services/AttachDocuments';

import { PartnerNaviList } from '../components/list/PartnerNaviList';
import { PartnerCompanySaftyForm } from '../components/forms/PartnerCompanySafty';
import Information from '../components/modals/common/Information';
import {
  INSURANCE_STATUS,
  WORKER_COMPENSATION_FLAG,
  CONST_SUBSCRIPTION_FLAG,
  ENTERPRISE_SUBSCRIPTION_FLAG,
  HEALTH_INSURANCE_FLAG,
  PENSION_FLAG,
  EMPLOYMENT_INSURANCE_FLAG,
} from '../utilities/companySafetyUtil';
import { attachDocumentCompanyDownload } from '../utilities/attachDocumentUtil';
import {
  getPartnerCompanyInfo,
  propsToCompanyId,
} from '../utilities/partnerCompanyConfirmUtil';
import { MasterPageHeader } from '../components/PageHeader';
import { RegionalDevelopmentBureauxService } from '../services/RegionalDevelopmentBureaux'; // 振興局情報API
import { CompanySyncDataCcusButton } from '../components/button/CompanyFetchDataCcusButton';
import PrimeCCUSPreviewService from '../services/PrimeCCUSPreview';

/**
 * 会社情報確認 画面  労務安全項目 タブ
 * 画面遷移
 *  - 協力会社管理者でログイン > 会社情報確認 > 労務安全項目
 */
export class CompanySaftyPreview extends React.Component {
  constructor(props) {
    super(props);

    this.selectedCompanyId = propsToCompanyId(this.props);
    this.isOwnCompany =
      Number(
        SessionStorageService.getItem('sessionPartnerCompanyIdOfPrimeCompany')
      ) === this.selectedCompanyId;

    this.events = {
      form: {
        download: this.download.bind(this),
      },
      goBack: this.goBack.bind(this),
    };

    this.state = {
      isLoading: false,
      userId: localStorage.getItem('user_id'),
      errorMessages: {}, // エラーメッセージ
      visibleDialogFlag: false,
      selectedCompanyName: '',
      isShowCcusButton: false,
      checkboxList: {
        construct_permit_source_types: {}, // 許可元区分名
        construct_permit_types: {}, // 建設許可区分名
        insurance_statuses: {}, // 健康保険、年金保険、雇用保険の加入状態
        workmans_compensation_insurance_statuses: {}, // 労災保険特別加入状況
        kentaikyo_insurance_statuses: {}, // 建退共制度加入状況
        chutaikyo_insurance_statuses: {}, // 中退共制度加入状況
        other_subscription_insurance_statuses: OTHER_SUBSCRIPTION_INSURANCE_STATUSES, // その他退職金共済制度加入状況
      },
      documentCodes: [],
      bureaux: [], // 振興局（APIから取得）
      formValues: {
        // 代表者情報
        company_detail: {
          delegate_name: '', // 代表者名
          delegate_name_kana: '', // 代表者名フリガナ
          delegate_post: '', // 代表者名役職
          construction_industry_permission_flag: EXISTANCE_FLAG.NOEXIST.VALUE, // 建設業許可有無フラグ
          acceptance_foreign_workers_flag: '', // 外国人就労者受入有無
          other_industry_permission_flag: '',
        },
        old_company_permission_documents: [],

        // 許可情報
        company_branch_permissions: [],
        security_company_branch_permission_group: {
          id: null,
          security_company_branch_permission_flag: EXISTANCE_FLAG.NOEXIST.VALUE,
          prefectures_code_id: null,
          permission_number_r: '',
          license_update_date: '',
          permission_group_type: PERMISSION_GROUP_TYPE.security,
          company_documents: [],
        },
        other_company_branch_permission_groups: [],
        // 保険情報
        company_branch_insurance: {
          health_insurance_flag: '', // 健康保険_加入状況
          ccus_health_insurance_reason_exclusion_code: '', // 社会保険適用外理由コード_健保
          health_insurance_reason_exclusion: '', // 健康保険_適用除外理由
          health_insurance_uninsured_reason: '', // 健康保険_(未加入の)理由
          health_insurance_type_code: '', // 健康保険_健康保険種類コード
          health_insurance_type: '', // 健康保険_健康保険種類
          health_insurance_name_insurer: '', // 健康保険_健康保険者名称
          health_insurance_office_symbol: '', // 健康保険_事業所整理記号
          health_insurance_office_number: '', // 健康保険_事業所整理番号
          pension_flag: '', // 年金保険_加入状況
          ccus_pension_reason_exclusion_code: '', // 社会保険適用外理由コード_年金
          pension_reason_exclusion: '', // 年金保険_適用除外理由
          pension_uninsured_reason: '', // 年金保険_(未加入の)理由
          pension_type_code: '', // 年金保険_年金種類コード
          pension_type: '', // 年金保険_年金保険種類名称
          pension_office_symbol: '', // 年金保険_事業所整理記号
          pension_office_number: '', // 年金保険_事業所番号
          employment_insurance_flag: '', // 雇用保険_加入状況
          ccus_employment_insurance_reason_exclusion_code: '', // 社会保険適用外理由コード_雇用
          employment_insurance_reason_exclusion: '', // 雇用保険_適用除外理由
          employment_insurance_uninsured_reason: '', // 雇用保険_(未加入の)理由
          employment_insurance_insurance_number: '', // 雇用保険_労働保険番号
          worker_compensation_flag: '', // 労災保険特別加入_加入状況
          worker_compensation_number: '', // 労災保険特別加入_労働保険番号
          worker_compensation_organize_number: '', // 労災保険特別加入_整理番号
          worker_add_on_compensation_flag: '', // 労災保険_労災上乗保険_加入状況
          const_subscription_flag: '', // 建設業退職金共済制度加入状況
          const_subscription_number: '', // 建設業退職金共済契約者番号
          enterprise_subscription_flag: '', // 中小企業退職金共済制度_加入状況
          enterprise_subscription_number: '', // 中小企業退職金共済契約者番号
        },

        // 外国人就労者情報
        company_branch_foreigner: {
          certification_number: '', // 適正監理計画認定番号
          supervisor_worker_id: null, // ワーカーID_受入監理責任者
          supervisor_name: '', // ワーカー名_受入監理責任者
          supervisor_position_name: '', // 役職名_受入監理責任者
          leader_worker_id: null, // ワーカーID_受入監理指導員
          work_place: '', // 外国人就労者_就労場所
          engagement_content: '', // 外国人就労者_従事業務内容
          work_category: '', // 外国人就労者_業務区分
          engagement_start_date: null, // 外国人就労者_従事開始年月日
          engagement_end_date: null, // 外国人就労者_従事終了年月日
        },
      },

      // ccusフォーム
      ccusformValues: {
        // 代表者情報
        ccus_jigyousyas: {
          daihyousya_name: '', // 代表者名
          daihyousya_kana_name: '', // 代表者名フリガナ
          construct_permit_availability: '', // 建設業許可有無フラグ
          construct_permit_number_type: '', // 許可元区分名「空白/00～47」
          jigyousya_construct_permit_source_type: '', // 許可元区分名「0,1,2」
          business_name: '', // 許可業種名
          construct_permit_number_year: '', // 許可番号年度
          construct_permit_number: '', // 許可番号固有番号
          start_date: '', // 許可年月日
          health_ins_status: '', // 健康保険加入状況
          health_ins_exclusion: '', // 健康保険適用除外理由
          pension_ins_status: '', // 年金保険加入状況
          pension_ins_exclusion: '', // 年金保険適用除外理由
          employment_ins_status: '', // ccus雇用保険加入状況
          employment_ins_exclusion: '', // ccus雇用保険適用除外理由
          workmans_comp_ins_status: '', // ccus労災保険特別加入状況
          kentaikyo_status: '', // ccus建退共制度加入状況
          kentaikyo_contractor_number: '', // ccus建退共契約者番号
          chutaikyo_status: '', // ccus中退共制度加入状況
        },
      },
      expirationCompany: {},
    };

    this.handleChangeSlide = this.handleChangeSlide.bind(this);
  }

  componentDidMount() {
    this.setCompanyInfo();
    this.getGreenData();
    this.getBasicInfo();
    this.getExpiration();

    const params = {
      offset: 0,
      is_limit: 0,
    };
    AttachDocuments.documentCodes(params).then(response => {
      if (!response.result) {
        return;
      }
      this.setState({
        documentCodes: response.data.entities.document_codes,
      });
    });
    CompanyService.companyDocuments(this.selectedCompanyId, params).then(
      response => {
        if (!response.result) {
          return;
        }
        this.setState({
          companyDocuments: response.data.entities.company_documents,
        });
      }
    );
  }

  getBasicInfo = async () => {
    const response = await PrimeCCUSPreviewService.getBasicInfo(
      this.selectedCompanyId
    );
    if (response.result) {
      const entities = response.data.entities;
      if (
        !_.isEmpty(entities.ccus_jigyousya_id) &&
        !_.isEmpty(_.get(entities, 'ccus_company_admin.ccus_company_admin_id'))
      ) {
        this.setState({
          isShowCcusButton: true,
          ccus_jigyousya_id: entities.ccus_jigyousya_id,
        });
      } else {
        this.setState({
          isShowCcusButton: false,
        });
      }
    } else {
      this.setState({
        isShowCcusButton: false,
      });
    }
  };

  setCompanyInfo = async () => {
    this.setState({ isLoading: true });
    const { company, companyName } = await getPartnerCompanyInfo(
      this.selectedCompanyId
    );
    this.setState({
      selectedCompanyName: companyName,
      ccus_jigyousya_id: company.ccus_jigyousya_id,
      isLoading: false,
    });
  };

  /**
   * 労務安全情報取得
   */
  getGreenData() {
    GreenService.list(this.selectedCompanyId).then(response => {
      if (!response.result) {
        this.setState({ isLoading: false });
        return;
      }
      const formValues = _.cloneDeep(this.state.formValues);
      const responseData = response.data.entities;
      _.map(responseData, (company_data, company_key) => {
        if (!_.includes(EXCLUDE_KEY_COMPANY_BRANCH_PERMISSIONS, company_key)) {
          _.map(company_data, (data, key) => {
            formValues[company_key][key] = data;
          });
        }
      });
      formValues.old_company_permission_documents = _.get(
        responseData,
        'old_company_permission_documents'
      );
      formValues.company_branch_permissions = _.get(
        responseData,
        'common_company_branch_permission_groups'
      );
      if (_.get(responseData, 'company_detail.security_permission_flag')) {
        formValues.security_company_branch_permission_group =
          responseData.security_company_branch_permission_group || {};
        formValues.security_company_branch_permission_group.security_company_branch_permission_flag =
          responseData.company_detail['security_permission_flag'];
      }
      formValues.other_company_branch_permission_groups =
        responseData.other_company_branch_permission_groups;

      formValues.company_detail.other_industry_permission_flag =
        _.get(responseData, 'company_detail.other_permission_flag') ||
        EXISTANCE_FLAG.NOEXIST.VALUE;
      this.setState({ formValues });
    });
    // 振興局情報APIから取得
    RegionalDevelopmentBureauxService.list().then(response => {
      if (!response.result) {
        return;
      }
      const bureaux = response.data.entities.regional_development_bureaux;
      this.setState({ bureaux });
    });

    GreenService.ccus_list().then(response => {
      if (!response.result) {
        return;
      }
      const checkboxList = _.cloneDeep(this.state.checkboxList);
      const responseData = response.data.entities;
      _.forEach(responseData, (ccus_list_data, ccus_list_key) => {
        if (_.has(checkboxList, ccus_list_key)) {
          checkboxList[ccus_list_key] = ccus_list_data;
        }
      });
      this.setState({ checkboxList });
    });
  }

  getExpiration = async () => {
    await CompanyService.expirations(this.selectedCompanyId).then(response => {
      if (!response.result) {
        return;
      }
      this.setState({
        expirationCompany: {
          ...this.state.expirationCompany,
          ...response.data.entities.company.expiration,
        },
      });
    });
  };

  async download(fileId) {
    attachDocumentCompanyDownload(
      () => {
        this.setState({
          visibleDialogFlag: true,
        });
      },
      this.selectedCompanyId,
      fileId
    );
  }

  /**
   * 画面遷移
   */
  handleChangeSlide = () => {
    SessionStorageService.setItem(
      'sessionSelectedPartnerCompanyId',
      this.selectedCompanyId
    );

    _masterSlideLoader.show('CompanySaftyEdit', {
      state: { id: this.selectedCompanyId },
    });
  };

  goBack = () => {
    _masterSlideLoader.show('AgencyCompanies', {
      state: {},
    });
  };

  /**
   * stateのcheckboxListと対応するvaluesで一致するオブジェクトを返す
   * checkboxListはAPIからデータが返ってくるまで空
   */
  findStatus = (type, targetValue) => {
    const fromInsuranceStatuses = targetValue => {
      if (!_.isEmpty(this.state.checkboxList.insurance_statuses)) {
        return this.state.checkboxList.insurance_statuses.find(
          item => item.value === targetValue
        );
      }
      return null;
    };
    const fromWorkmansCompensationInsuranceStatuses = targetValue => {
      if (
        !_.isEmpty(
          this.state.checkboxList.workmans_compensation_insurance_statuses
        )
      ) {
        return this.state.checkboxList.workmans_compensation_insurance_statuses.find(
          item => item.value === targetValue
        );
      }
      return null;
    };
    const fromKentaikyoInsuranceStatuses = targetValue => {
      if (!_.isEmpty(this.state.checkboxList.kentaikyo_insurance_statuses)) {
        return this.state.checkboxList.kentaikyo_insurance_statuses.find(
          item => item.value === targetValue
        );
      }
      return null;
    };
    const fromChutaikyoInsuranceStatuses = targetValue => {
      if (!_.isEmpty(this.state.checkboxList.chutaikyo_insurance_statuses)) {
        return this.state.checkboxList.kentaikyo_insurance_statuses.find(
          item => item.value === targetValue
        );
      }
      return null;
    };
    switch (type) {
      case INSURANCE_STATUS:
      case HEALTH_INSURANCE_FLAG:
      case PENSION_FLAG:
      case EMPLOYMENT_INSURANCE_FLAG:
        return fromInsuranceStatuses(targetValue);
      case WORKER_COMPENSATION_FLAG:
        return fromWorkmansCompensationInsuranceStatuses(targetValue);
      case CONST_SUBSCRIPTION_FLAG:
        return fromKentaikyoInsuranceStatuses(targetValue);
      case ENTERPRISE_SUBSCRIPTION_FLAG:
        return fromChutaikyoInsuranceStatuses(targetValue);
      default:
        return null;
    }
  };

  closeError = () => {
    this.setState({
      visibleDialogFlag: false,
    });
  };

  render() {
    const {
      isLoading,
      selectedCompanyName,
      ccus_jigyousya_id,
      isShowCcusButton,
    } = this.state;
    const title = `${selectedCompanyName} 会社情報`;

    return (
      <div id='slide-view' className='contruction-slide-view show'>
        <Helmet>
          <title>
            {HEADER_CONSTANTS.title} - {title}
          </title>
        </Helmet>
        <div className='contruction-slide-view__view'>
          <MasterPageHeader
            loaded={!isLoading}
            loaderComponent={
              <div className='contruction-slide-view__title'>
                <ClipLoader size={20} color={'#EDB715'} />
              </div>
            }
            title={title}
            onClose={() => _masterSlideLoader.close()}
          />
          <div className='contruction-slide-view__body contruction-slide-view__body--height-fix'>
            <div className='contruction-detail-view'>
              <div className='contruction-detail-view__sidemenu'>
                <PartnerNaviList
                  isCompanySaftyInfo
                  selectedPartnerCompanyId={this.selectedCompanyId}
                  expirationCompany={this.state.expirationCompany}
                />
              </div>
              <div className='contruction-detail-view__body contruction-detail-view__body--fixed'>
                {!this.isOwnCompany && (
                  <div style={{ padding: '10px 20px 0' }}>
                    <button
                      className='btn-text--sm'
                      onClick={() => {
                        this.events.goBack();
                      }}
                    >
                      <i className='i-back--blue i-2x vertical-middle' />
                      代行先一覧
                    </button>
                  </div>
                )}
                <div className='contruction-detail-view__menu'>
                  <span className='construction-detail-view__button'>
                    <button className='btn' onClick={this.handleChangeSlide}>
                      編集
                    </button>
                  </span>
                  <span className='construction-detail-view__button'>
                    {/* TODO: A-836(A-2)の実装でCCUS取得ボタンに関する内容を詳細画面から削除する */}
                    {/* {isShowCcusButton && (
                      <CompanySyncDataCcusButton
                        ccusid={ccus_jigyousya_id}
                        selected_partner_company_id={String(
                          this.selectedCompanyId
                        )}
                      />
                    )} */}
                  </span>
                </div>
                <div className='contruction-detail-view__bar' />
                <PartnerCompanySaftyForm
                  values={this.state.formValues}
                  messages={this.state.errorMessages}
                  checkboxList={this.state.checkboxList}
                  ccusformValues={this.state.ccusformValues}
                  comboboxList={{}}
                  events={this.events.form}
                  readOnly={true}
                  findStatusFn={this.findStatus}
                  companyDocuments={this.state.companyDocuments}
                  documentCodes={this.state.documentCodes}
                  bureaux={this.state.bureaux}
                  companyId={this.selectedCompanyId}
                  eventCompanyBranchPermissionCommon={this.events.form}
                />
                <Information
                  title={
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                      }}
                    >
                      <i
                        className='icon-error'
                        style={{
                          fontSize: 24,
                          color: 'red',
                        }}
                      />
                      <p>エラーが発生しました。</p>
                    </div>
                  }
                  message={'指定されたファイルが存在しません。'}
                  buttonText={messageUtility.getMessage('I-000-017')}
                  visible={this.state.visibleDialogFlag}
                  onClose={() => {
                    this.closeError();
                  }}
                  multilineText
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/CompanySaftyPreview.jsx